import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import {
    LoginResponse,
    SignupInput,
    RestAuthGroupConfig,
    User,
    UserDto,
} from '@mattrika/benefit-model'
import { ApiResponse, ApiService } from '@touhidrahman/ngx-common'
import { Observable } from 'rxjs'
import { BENEFIT_ENVIRONMENT } from '../environment/environment.injector'

@Injectable({
    providedIn: 'root',
})
export class AuthApiService extends ApiService<User, UserDto> {
    constructor() {
        super(`${inject(BENEFIT_ENVIRONMENT).apiUrl}/auth`, inject(HttpClient))
    }

    login(
        identifier: string,
        password: string,
    ): Observable<ApiResponse<LoginResponse>> {
        return this.http.post<ApiResponse<LoginResponse>>(
            `${this.apiUrl}/login`,
            {
                identifier,
                password,
            },
        )
    }

    register(input: SignupInput): Observable<ApiResponse<User>> {
        return this.http.post<ApiResponse<User>>(
            `${this.apiUrl}/register`,
            input,
        )
    }

    changePassword(
        currentPassword: string,
        password: string,
    ): Observable<ApiResponse<boolean>> {
        return this.http.post<ApiResponse<boolean>>(
            `${this.apiUrl}/change-password`,
            {
                password,
                currentPassword,
            },
        )
    }

    forgotPassword(
        identifierType: 'email' | 'phone',
        identifierValue: string,
    ): Observable<ApiResponse<{ token: string }>> {
        return this.http.post<ApiResponse<{ token: string }>>(
            `${this.apiUrl}/forgot-password`,
            { identifierType, identifierValue },
        )
    }

    resetPassword(
        token: string,
        password: string,
        passwordConfirmation: string,
    ): Observable<ApiResponse<boolean>> {
        return this.http.post<ApiResponse<boolean>>(
            `${this.apiUrl}/reset-password/${token}`,
            { password, passwordConfirmation },
        )
    }

    refreshAccessToken(
        refreshToken: string,
    ): Observable<ApiResponse<LoginResponse>> {
        return this.http.post<ApiResponse<LoginResponse>>(
            `${this.apiUrl}/token`,
            {
                refreshToken,
            },
        )
    }

    verifyEmail(token: string): Observable<ApiResponse<unknown>> {
        return this.http.post<ApiResponse<unknown>>(
            `${this.apiUrl}/verify-email/${token}`,
            {},
        )
    }

    getRestAuthGroups(): Observable<ApiResponse<RestAuthGroupConfig[]>> {
        return this.http.get<ApiResponse<RestAuthGroupConfig[]>>(
            `${this.apiUrl}/restauth-groups`,
        )
    }
}
